import 'react-app-polyfill/stable';
import '@bd-uikit-web/styles/_base.scss';
import './styles/main.scss';

import React from 'react';
import { render } from 'react-dom';
import { HashRouter, Switch, Route } from 'react-router-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';

import reducer from './store/reducer';

import SplashScreen from './pages/SplashScreen';
import Featured from './pages/Featured';
import Layout from './pages/Layout';
import Pair from './pages/Pair';
import Error from './pages/Error';
import Account from './pages/Account';
import Playlist from './pages/Playlist';
import Notice from './pages/Notice';
import Policy from './pages/Policy';
import Offline from './pages/offline';
import Agreement from './pages/Agreement';
import bdReq from '../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../@packages/@bd-uikit-web/js-helpers/bdAuth';

bdReq.setApiUrl('https://api.blackdove.io');
// bdReq.setApiUrl('http://192.168.0.13:3004');

bdAuth.setAppId("fdea8d89jufd89kfff");
bdAuth.setUserEndpoint('/me');

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(thunk)));
const persistor = persistStore(store);

render(
  (
    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
      <Layout>
        <HashRouter>
          <Switch>
            <Route exact path="/" component={SplashScreen} />
            <Route path="/pair" component={Pair} />
            <Route path="/error" component={Error} />
            <Route path="/account" component={Account} />
            <Route path="/featured" component={Featured} />
            <Route path="/playlist/:playlistId" component={Playlist} />
            <Route path="/notice/:id?" component={Notice} />
            <Route path="/agreement" component={Agreement} />
            <Route path="/policy" component={Policy} />
            <Route path="/offline" component={Offline} />
          </Switch>
        </HashRouter>
      </Layout>
      </PersistGate>
    </Provider>
  ), document.getElementById('app'));
